export default __webpack_public_path__ + "static/media/bg-talk-4.568aa738.png";